import Loader from '../../Loader/Loader'

const AttendeesLoader = () => {
  return (
    <div className="attendees_loader">
      <Loader />
    </div>
  )
}

export default AttendeesLoader
